<template>
  <div class="config_main_manage_background">
    <!-- 设置页面的内容区域 -->
    <div class="config_main_manage_page_wraper">
      <div class="config_main_manage_page_content">
        <!-- 设置页面  内容区域样式   以上部分都是公共样式 -->
        <config-title-hang>
          <span slot="config_title_hang_ele2">{{ServeOneObjectinfo.remark}}</span>
        </config-title-hang>

        <!-- 服务器返回的所有区域列表 -->
        <config-hang>
          <span slot="config_hang_ele2">当前系统时间：{{serveTimeData.serviceTime}}</span>
        </config-hang>
        <config-hang>
          <span slot="config_hang_ele2">当前设备时间：{{serveTimeData.deviceTime}}</span>
        </config-hang>

        <config-hang @click.native="updataTimeBtnHandle">
          <span slot="config_hang_ele_xia_zai">刷新时间显示</span>
        </config-hang>

        <config-hang @click.native="updataDeviceTimeBtnHandle">
          <span slot="config_hang_ele_xia_zai">同步更新设备时间</span>
        </config-hang>
        <div class="xiaotishi_style">小提示：当前系统时间和当前设备时间有几秒或几十秒的差异属正常情况。</div>
        <div class="public_config_que_ren_btn" @click="saveReturnBtnHandle">保存并返回</div>
      </div>
    </div>
  </div>
</template>

<script>
import topNav from "components/common/topnav/topnav";
import topNavItem from "components/common/topnav/topnavitem";
import configHang from "components/common/config/config-hang";
import configTitleHang from "components/common/config/config-title-hang";
// import { mediumslateblue } from "color-name";
import { configPageDataRequest } from "views/afterLogin/config/deviceManagePage/deviceListPage/public_config_requery_js";

export default {
  data() {
    return {
      serveTimeData: {
        deviceTime: "",
        serviceTime: ""
      },

      ServeOneObjectinfo: {
        ////地址指向仓库  当前要进行设置对象的信息
      }
    };
  },
  computed: {},
  components: {
    topNav,
    topNavItem,
    configHang,
    configTitleHang
  },
  methods: {
    updataTimeBtnHandle() {
      ///刷新时间按钮
      /// 读取定时设备时间接口，获取数据
      this.$request({
        method: "post",
        url: "/device/findDeviceTimeByDeviceId",
        data: {
          token: this.$store.state.token,
          deviceId: this.ServeOneObjectinfo.deviceId
        }
      })
        .then(res => {
          if (res.data.code != 0) {
            this.$showTipsToast(3, res.data.message);
            ////说明信息填写错误,控制失败了，
            return;
          } else {
            ////、控制成功了
            this.serveTimeData = res.data.data; ////拿到服务器返回的数据结果
            console.log(this.serveTimeData);
            // this.$showTipsToast(1, "获取成功", true); ////提示框
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    updataDeviceTimeBtnHandle() {
      ///更新设备时间按钮
      ///同步设备时间接口，获取数据
      this.$request({
        method: "post",
        url: "/device/synchroTimeByDeviceId",
        data: {
          token: this.$store.state.token,
          deviceId: this.ServeOneObjectinfo.deviceId
        }
      })
        .then(res => {
          if (res.data.code != 0) {
            this.$showTipsToast(3, res.data.message);
            ////说明信息填写错误,控制失败了，
            return;
          } else {
            ////、控制成功了
            this.updataTimeBtnHandle()
            // this.$showTipsToast(1, "获取成功", true); ////提示框
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    saveReturnBtnHandle(){
      this.$router.go(-1)
    }
  },
  created() {
    console.log("created阶段");
    this.ServeOneObjectinfo = this.$store.state.configinfo.ServeOneObjectinfo; ////一个对象的地址信息拿过来
    /// 读取定时设备时间接口，获取数据
    this.$request({
      method: "post",
      url: "/device/findDeviceTimeByDeviceId",
      data: {
        token: this.$store.state.token,
        deviceId: this.ServeOneObjectinfo.deviceId
      }
    })
      .then(res => {
        if (res.data.code != 0) {
          this.$showTipsToast(3, res.data.message);
          ////说明信息填写错误,控制失败了，
          return;
        } else {
          ////、控制成功了
          this.serveTimeData = res.data.data; ////拿到服务器返回的数据结果
          console.log(this.serveTimeData);
          // this.$showTipsToast(1, "获取成功", true); ////提示框
        }
      })
      .catch(error => {
        console.log(error);
      });
  }
};
</script>

<style>
</style>